module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-9-f355799e16da270d38a5fffed4042c85.webp";